import React, { Component } from 'react';
import { clearCtx, drawLine, coordTransformFromCtx } from './drawhelp';

class HandDraw extends Component {
	constructor(props) {
		super(props);
		this.canvas = React.createRef();
		this.state = { length: 0 };
		this.drawn_track = [];
		this.raw_track = [];
		this.flag = false;
	}

	componentDidMount() {
		this.ctx = this.canvas.current.getContext("2d");

		this.canvas.current.addEventListener("mousemove", (e) => this.findxy('move', e), true);
		this.canvas.current.addEventListener("mousedown", (e) => this.findxy('down', e), true);
		this.canvas.current.addEventListener("mouseup", (e) => this.findxy('up', e), true);
		this.canvas.current.addEventListener("mouseout", (e) => this.findxy('out', e), true);

		this.canvas.current.addEventListener("touchstart", (e) => this.findxy('touchstart', e), true);
		this.canvas.current.addEventListener("touchmove", (e) => this.findxy('touchmove', e), true);
		this.canvas.current.addEventListener("touchend", (e) => this.findxy('touchend', e), true);
		this.clear();
	}

	clear() {
		this.drawn_track = [];
		this.raw_track = [];
		this.flag = false;
		clearCtx(this.ctx);
		drawLine(
			this.ctx, 0, .9, 0, -.9,
			{ color: "#ccc" });
		drawLine(
			this.ctx, .9, 0, -.9, 0,
			{ color: "#ccc" });
		this.setState({ length: 0 });
	}

	findxy(res, e) {
		if (res === 'up' || res === "out" || res === "touchend") {
			this.flag = false;
			return false;
		}
		e.preventDefault();
		e.stopPropagation();
		let x;
		let y;
		if ((e.type === 'touchstart' || e.type === 'touchmove' ||
			e.type === 'touchend' || e.type === 'touchcancel') &&
			(e.touches || e.changedTouches)) {
			var touch = e.touches[0] || e.changedTouches[0];
			x = touch.pageX;
			y = touch.pageY;
		} else if (e.type === 'mousedown' || e.type === 'mouseup' ||
			e.type === 'mousemove' || e.type === 'mouseover' ||
			e.type === 'mouseout' || e.type === 'mouseenter' ||
			e.type === 'mouseleave') {
			x = e.clientX;
			y = e.clientY;
		}

		let prevX = this.ctx_X;
		let prevY = this.ctx_Y;
		this.currX = x - this.canvas.current.getBoundingClientRect().left;
		this.currY = y - this.canvas.current.getBoundingClientRect().top;

		[this.ctx_X, this.ctx_Y] = coordTransformFromCtx(this.ctx, this.currX, this.currY);

		if (res === 'down' || res === 'touchstart') {
			this.flag = true;

			this.drawn_track.push([this.ctx_X, this.ctx_Y]);
			this.raw_track.push([
				- (this.ctx.canvas.width / 2 - this.currX),
				this.ctx.canvas.height / 2 - this.currY]);
		}
		if (res === 'move' || res === 'touchmove') {
			if (this.flag) {
				if (this.drawn_track.length > 0)
					drawLine(this.ctx, prevX, prevY, this.ctx_X, this.ctx_Y,
						{ color: "#ff0000", width: 2 });
				// Set last point as end not of line
				if (this.drawn_track.length > 0) {
					this.drawn_track[this.drawn_track.length - 1][2] = false;
					this.raw_track[this.raw_track.length - 1][2] = false;
				}
				this.drawn_track.push([this.ctx_X, this.ctx_Y, true]);
				this.raw_track.push([
					- (this.ctx.canvas.width / 2 - this.currX),
					this.ctx.canvas.height / 2 - this.currY,
					true]);
			}
		}
		this.setState({ length: this.drawn_track.length });
		return false;
	}

	use() {
		this.props.setPointsCallback(this.drawn_track, this.raw_track, 0);
		this.props.setMode("view");
	}

	render() {
		const buttonstyle = {
			fontSize: "120%"
		};
		return (
			<div>
				<button style={buttonstyle} disabled={this.state.length > 0 ? false : true} onClick={() => this.clear()}>Clear image</button>
				<button style={buttonstyle} disabled={this.state.length > 0 ? false : true} onClick={() => this.use()}>Use drawing</button>
				<br />
				<canvas
					ref={this.canvas}
					width={800}
					height={600}
					style={{ border: "1px solid black" }}
				/>
			</div>
		);
	}
}

export default HandDraw;